// extracted by mini-css-extract-plugin
export default {"root":"MEbg8jIh","header":"P97rYp1K","folder":"uC9KwIK7","interactive":"db2WsIPg","subfolder":"qqdPrxSH","site":"dNJuuV1f","small":"rQOZaBwJ","icon":"yWoCn5kk","scalable":"d8pMxoBU"};